import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseAvatarSize, BaseDeliveryTimeListItemExtendedInterface } from 'base';

@Component({
  selector: 'base-customer-inquired-service-provider-list-item',
  templateUrl: './base-customer-inquired-service-provider-list-item.component.html',
})
export class BaseCustomerInquiredServiceProviderListItemComponent {
  @Input({ required: true }) providerInfo: BaseDeliveryTimeListItemExtendedInterface;
  @Input({ required: true }) isInquiryClosed: boolean;
  @Output() itemSelect = new EventEmitter<{ branchId: number; isSelected: boolean }>();

  avatarSize = BaseAvatarSize;

  onItemSelect(isSelected: boolean): void {
    this.itemSelect.emit({ branchId: this.providerInfo.pspBranch.id as number, isSelected });
  }
}
